module.exports = __webpack_public_path__ + "img/pago-exitoso.ac7f6d83.svg";